import React, {useEffect, useState} from "react";
import {css} from "@emotion/react";

import {display, p, pointer} from "@pg-design/helpers-css";
import {Loader} from "@pg-design/loader-module";
import {Text} from "@pg-design/text-module";
import {convertToLatLngLiteralOfPoland} from "@pg-mono/open-street-map";

import {formatDuration, TravelMode} from "../../property/utils/TravelMode";
import {fetchTravelDirections} from "../actions/fetch_travel_directions";

interface IProps {
    offer: {
        geo_point: {
            coordinates: [number, number];
        };
        stats: {
            distance_from_region: {
                center: boolean;
                coords: [number, number];
                region: string;
            };
        } | null;
    };
}

export const RegionCenterDriveTime = (props: IProps) => {
    const [showTime, setShowTime] = useState(false);
    const [driveTimeData, setDriveTimeData] = useState<{time: number | null; error: boolean; loading: boolean}>({time: null, error: false, loading: false});

    useEffect(() => {
        if (showTime) {
            const {lng, lat} = convertToLatLngLiteralOfPoland(props.offer.geo_point.coordinates);

            if (props.offer.stats?.distance_from_region.coords) {
                const {lng: centerLng, lat: centerLat} = convertToLatLngLiteralOfPoland(props.offer.stats?.distance_from_region.coords);
                setDriveTimeData((prev) => ({...prev, loading: true}));

                const promise = (travelMode: TravelMode) =>
                    fetchTravelDirections({origin: {lat, lng}, destination: {lat: centerLat, lng: centerLng}, travelMode});

                promise(TravelMode.TRANSIT).then((transit) => {
                    if (transit) {
                        return setDriveTimeData({time: transit.value, error: false, loading: false});
                    }

                    promise(TravelMode.DRIVING).then((driving) => {
                        setDriveTimeData({time: driving ? driving.value : null, error: !driving, loading: false});
                    });
                });
            }
        }
    }, [showTime]);

    const {center, region = ""} = props.offer.stats?.distance_from_region || {};

    const renderContent = () => {
        if (driveTimeData.loading) {
            return (
                <span css={display("inline-flex")}>
                    <Loader size="xsm" css={p(0)} />
                </span>
            );
        }

        if (!!driveTimeData.time) {
            return <strong>{formatDuration(driveTimeData.time)}</strong>;
        }

        if (driveTimeData.error) {
            return <span>brak danych</span>;
        }

        return (
            <span css={showTimeButton} onClick={() => setShowTime(true)}>
                pokaż
            </span>
        );
    };

    return (
        <div css={centerDriveTime}>
            <Text variant="body_copy_1">
                Dojazd do centrum{!center && ` ${region}`}: {renderContent()}
            </Text>
        </div>
    );
};

const centerDriveTime = css`
    position: relative;
    display: flex;
    align-items: center;
`;

const showTimeButton = css`
    ${pointer};
    text-decoration: underline;
`;
import React, {useEffect, useState} from "react";
import {css} from "@emotion/react";

import {display, p, pointer} from "@pg-design/helpers-css";
import {Loader} from "@pg-design/loader-module";
import {Text} from "@pg-design/text-module";
import {convertToLatLngLiteralOfPoland} from "@pg-mono/open-street-map";

import {formatDuration, TravelMode} from "../../property/utils/TravelMode";
import {fetchTravelDirections} from "../actions/fetch_travel_directions";

interface IProps {
    offer: {
        geo_point: {
            coordinates: [number, number];
        };
        stats: {
            distance_from_region: {
                center: boolean;
                coords: [number, number];
                region: string;
            };
        } | null;
    };
}

export const RegionCenterDriveTime = (props: IProps) => {
    const [showTime, setShowTime] = useState(false);
    const [driveTimeData, setDriveTimeData] = useState<{time: number | null; error: boolean; loading: boolean}>({time: null, error: false, loading: false});

    useEffect(() => {
        if (showTime) {
            const {lng, lat} = convertToLatLngLiteralOfPoland(props.offer.geo_point.coordinates);

            if (props.offer.stats?.distance_from_region.coords) {
                const {lng: centerLng, lat: centerLat} = convertToLatLngLiteralOfPoland(props.offer.stats?.distance_from_region.coords);
                setDriveTimeData((prev) => ({...prev, loading: true}));

                const promise = (travelMode: TravelMode) =>
                    fetchTravelDirections({origin: {lat, lng}, destination: {lat: centerLat, lng: centerLng}, travelMode});

                promise(TravelMode.TRANSIT).then((transit) => {
                    if (transit) {
                        return setDriveTimeData({time: transit.value, error: false, loading: false});
                    }

                    promise(TravelMode.DRIVING).then((driving) => {
                        setDriveTimeData({time: driving ? driving.value : null, error: !driving, loading: false});
                    });
                });
            }
        }
    }, [showTime]);

    const {center, region = ""} = props.offer.stats?.distance_from_region || {};

    const renderContent = () => {
        if (driveTimeData.loading) {
            return (
                <span css={display("inline-flex")}>
                    <Loader size="xsm" css={p(0)} />
                </span>
            );
        }

        if (!!driveTimeData.time) {
            return <strong>{formatDuration(driveTimeData.time)}</strong>;
        }

        if (driveTimeData.error) {
            return <span>brak danych</span>;
        }

        return (
            <span css={showTimeButton} onClick={() => setShowTime(true)}>
                pokaż
            </span>
        );
    };

    return (
        <div css={centerDriveTime}>
            <Text variant="body_copy_1">
                Dojazd do centrum{!center && ` ${region}`}: {renderContent()}
            </Text>
        </div>
    );
};

const centerDriveTime = css`
    position: relative;
    display: flex;
    align-items: center;
`;

const showTimeButton = css`
    ${pointer};
    text-decoration: underline;
`;
